export const PagerComponent = {
	bindings: {
		currentPage: '<',
		maxPages: '<',
		pageNumberToDispay: '<',
		onPageClick: '&'
	},
	templateUrl: 'pager.html',
	controller: class PagerComponent {
		constructor() {
			'ngInject';
			this.page = 1;
			this.currentPageNumber = 0;
		}

		getMaxPageNumber(number) {
			return new Array(number);
		}

		$onChanges(changes) {
			if (changes.maxPages) {
				this.maxPage = angular.copy(this.maxPages);
			}
			if (changes.currentPage) {
				this.currentPageNumber = angular.copy(this.currentPage);
			}
		}

		onPage(page) {
			if (!(page == this.maxPage || page < 0)) {
				this.onPageClick({
					$event: {
						pageTo: page
					}
				});
			}
		}
	}
};
